__turbopack_context__.v({
  "active": "FilterGridSection-module__-pDvsG__active",
  "card": "FilterGridSection-module__-pDvsG__card",
  "contentArea": "FilterGridSection-module__-pDvsG__contentArea",
  "eyebrow": "FilterGridSection-module__-pDvsG__eyebrow",
  "grid": "FilterGridSection-module__-pDvsG__grid",
  "gridContainer": "FilterGridSection-module__-pDvsG__gridContainer",
  "header": "FilterGridSection-module__-pDvsG__header",
  "iconBox": "FilterGridSection-module__-pDvsG__iconBox",
  "itemName": "FilterGridSection-module__-pDvsG__itemName",
  "navBtn": "FilterGridSection-module__-pDvsG__navBtn",
  "section": "FilterGridSection-module__-pDvsG__section",
  "sidebar": "FilterGridSection-module__-pDvsG__sidebar",
  "subtitle": "FilterGridSection-module__-pDvsG__subtitle",
  "title": "FilterGridSection-module__-pDvsG__title",
});
